/**
 * Ensure the firm's getting-started demo matters exist (VALE-1265).
 *
 * The guided tours run inside seeded demo matters. Before this, those matters
 * appeared only when a Vale staff member ran the ops seed action against the
 * firm, so a firm nobody had seeded saw its tours as dead rows. The launcher
 * (`useGettingStartedStepLauncher`) now calls this on the way into a tour.
 *
 * Idempotent and firm-scoped on the backend: it takes no arguments precisely
 * because there is nothing for the client to choose — the firm, the owner and
 * the demo-mail recipient are all read off the authenticated user.
 */

import { directApiClient, DirectApiError } from '@/lib/api/direct-client';

export interface EnsuredDemoMatter {
  id: number;
  /** e.g. `DEMO-001` — how the tours address a demo matter. */
  reference: string;
}

export interface EnsureDemoMattersResponse {
  matters: EnsuredDemoMatter[];
  /** Zero when the firm was already set up. */
  createdCount: number;
}

export async function ensureDemoMatters(): Promise<EnsureDemoMattersResponse> {
  try {
    return await directApiClient.post<EnsureDemoMattersResponse>(
      '/onboarding/demo-matters',
      undefined
    );
  } catch (error) {
    if (error instanceof DirectApiError) {
      throw new Error(error.message);
    }
    throw error instanceof Error ? error : new Error('Request failed');
  }
}
